export const getShowListDependentFlags = (showList, previousDefault = 0) => {
  const enabled = Number(showList) === 1;

  return {
    t_requires_ref: enabled ? 1 : 0,
    t_default: enabled ? 1 : previousDefault,
  };
};
